import React, { useEffect, useState } from 'react';
import { Provider } from 'react-redux';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import App from './App';
import ErrorComponent from './components/shared/errors/ErrorComponent';
import CommonLoader from './components/shared/loaders/CommonLoader';
import createAppStore from './redux/store';

const AppContainer = () => {
  const [store, setStore] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const controller = new AbortController();

    const initialize = async () => {
      try {
        const appStore = await createAppStore();
        if (controller.signal.aborted) return;
        setStore(appStore);
      } catch (error) {
        if (controller.signal.aborted) return;
        setError(`Error initializing the application: ${error.message}`);
      } finally {
        if (!controller.signal.aborted) {
          setLoading(false);
        }
      }
    };

    initialize();
    return () => controller.abort();
  }, []);

  if (loading || error) {
    return (
      <div className="flex item-center justify-center h-screen">
        {loading ? <CommonLoader /> : <ErrorComponent errorMessage={error} />}
      </div>
    );
  }

  return (
    <Provider store={store}>
      <ToastContainer
        position="bottom-right"
        autoClose={1000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
      <App />
    </Provider>
  );
};

export default AppContainer;
